(() => {
  const loader = document.querySelector('[data-athena-page-loader]');

  if (!loader) return;

  const body = document.body;
  const minimumTime = Number.parseInt(loader.dataset.minimumTime, 10) || 0;
  const startedAt = performance.now();
  let dismissed = false;

  const removeLoader = () => {
    if (dismissed) return;
    dismissed = true;
    loader.classList.add('is-leaving');
    loader.setAttribute('aria-hidden', 'true');
    body.classList.remove('athena-loader-active');

    window.setTimeout(() => loader.remove(), 550);
  };

  const dismissLoader = () => {
    const remainingTime = Math.max(0, minimumTime - (performance.now() - startedAt));
    window.setTimeout(removeLoader, remainingTime);
  };

  if (window.Shopify?.designMode) {
    removeLoader();
    return;
  }

  if (document.readyState === 'complete') {
    dismissLoader();
  } else {
    window.addEventListener('load', dismissLoader, { once: true });
  }

  // Never leave checkout navigation or the storefront blocked by a failed asset.
  window.setTimeout(removeLoader, Math.max(5000, minimumTime + 3000));
})();
